import * as yup from 'yup'

const onlyDigits = (value?: string) => (value || '').replace(/\D/g, '')

export const customerSchema = yup.object({
  name: yup.string().trim().required('Informe o nome ou a razão social'),
  document: yup
    .string()
    .required('Informe o CPF ou CNPJ')
    .test('document', 'CPF ou CNPJ inválido', (value) =>
      [11, 14].includes(onlyDigits(value).length)
    ),
  email: yup
    .string()
    .trim()
    .email('E-mail inválido')
    .required('Informe o e-mail de cobrança'),
  phone: yup
    .string()
    .required('Informe o telefone')
    .test(
      'phone',
      'Telefone inválido',
      (value) => onlyDigits(value).length >= 10
    ),
  postal_code: yup
    .string()
    .required('Informe o CEP')
    .test('cep', 'CEP inválido', (value) => onlyDigits(value).length === 8),
  street: yup.string().trim().required('Informe a rua'),
  number: yup.string().trim().required('Informe o número'),
  complement: yup.string().trim(),
  neighborhood: yup.string().trim().required('Informe o bairro'),
  city: yup.string().trim().required('Informe a cidade'),
  state: yup
    .string()
    .trim()
    .required('Selecione o estado')
    .length(2, 'Selecione o estado')
})

export type CustomerFormData = yup.InferType<typeof customerSchema>
